const styles = {
  icon: {
    marginRight: 16,
    fontSize: 24,
  },
};

export default styles;
